import { render, staticRenderFns } from "./JobsKeywordsReport.vue?vue&type=template&id=19bf44ff&scoped=true&"
import script from "./JobsKeywordsReport.vue?vue&type=script&lang=js&"
export * from "./JobsKeywordsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bf44ff",
  null
  
)

export default component.exports